var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyButtonLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 7.5,
    stroke: "#CCD3DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 14.0156V18.9996H35.86L31 14.0156Z",
    fill: "#8C96A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21V14H24C23.2044 14 22.4413 14.3161 21.8787 14.8787C21.3161 15.4413 21 16.2044 21 17V33H36V21H29Z",
    fill: "#8C96A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35V18C18.2044 18 17.4413 18.3161 16.8787 18.8787C16.3161 19.4413 16 20.2044 16 21V38H32V35H19Z",
    fill: "#8C96A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButtonLink);
export default __webpack_public_path__ + "static/media/CopyButtonLink.7bf8a8e7b0e49a57780a35133807ba44.svg";
export { ForwardRef as ReactComponent };